import { SpinMutation3rsfya4nf2aew as SpinMutation } from './schema/SpinMutation.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  Success_instance19a3p6fd6aqm8 as Success_instance,
  Dispatchernurlbopdkn3a as Dispatcher,
} from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/SpinCommand.mjs';
import { Unauthorized_instance2jgb1jb3jobqz as Unauthorized_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { NotEmptyList__toList_impl_nbkblo3cfi667zq3p3o as NotEmptyList__toList_impl_nbkblo } from '../../../../../types-types/kotools/types/collection/NotEmptyList.mjs';
import { SpinInputg1yg8g6z8wv9 as SpinInput } from './schema/type/SpinInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_perform__v6ng8j($this, command, $completion) {
  var tmp = $this.o6q(new (SpinMutation())(spinInput(command)), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp.l44_1;
  var tmp_0;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x6g_1) == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = Success_instance;
  }
  var tmp2_elvis_lhs = tmp_0;
  return tmp2_elvis_lhs == null ? Unauthorized_instance : tmp2_elvis_lhs;
}
function perform(command, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_perform__v6ng8j.bind(VOID, this, command), $completion);
}
var SdkSpinClass;
function SdkSpin() {
  if (SdkSpinClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSpin', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSpinClass = $;
  }
  return SdkSpinClass;
}
function spinInput(_this__u8e3s4) {
  return new (SpinInput())(_this__u8e3s4.b2k_1, NotEmptyList__toList_impl_nbkblo(_this__u8e3s4.c2k_1), _this__u8e3s4.d2k_1);
}
//region block: exports
export {
  SdkSpin as SdkSpin3glo2r2cb0vqe,
  perform as perform32xwahz7kfsec,
};
//endregion

//# sourceMappingURL=SdkSpin.mjs.map
